import React from 'react';
import style from './EmployeeItem.module.css';
import { avatarColor, initialOf } from '../../../common/avatar';

interface OwnerItemProps {
  name: string;
  email?: string;
  phone?: string;
  avatarUrl?: string;
}

/**
 * §FB172. Рядок керівника компанії над списком співробітників. Керівник — це обліковий запис
 * самої компанії, у списку співробітників його немає, а роль «Адміністратор компанії» в нього
 * автоматична: замість тумблера — підпис «автоматично». Інших ролей рядка в нього немає, як і
 * кнопки видалення.
 */
const OwnerItem: React.FC<OwnerItemProps> = ({
  name,
  email,
  phone,
  avatarUrl,
}) => (
  <div className={`${style.itemContainer} ${style.ownerRow}`}>
    <div className={style.additionalElement}>—</div>
    <div className={style.wrapInfo}>
      {avatarUrl ? (
        <img src={avatarUrl} alt={name} />
      ) : (
        <span
          className={style.avatarInitial}
          style={{ backgroundColor: avatarColor(name || '') }}
        >
          {initialOf(name || '')}
        </span>
      )}
      <p>{name}</p>
      <span className={style.ownerTag}>Керівник компанії</span>
    </div>
    <p>{email}</p>
    <p>{phone}</p>
    <div className={style.togglesCell}>
      <span className={style.noRole}>—</span>
      <span className={style.noRole}>—</span>
      <span
        className={style.autoNote}
        title="Керівник компанії — адміністратор компанії автоматично"
      >
        автоматично
      </span>
    </div>
    <span />
  </div>
);

export default OwnerItem;
